import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import InternalLink from '../../../components/InternalLink'
import { ReactComponent as IconBack } from '../../../assets/icons/chevron-arrow-down.svg'

import { ReactComponent as ArrowIcon } from '../../../assets/icons/right-arrow.svg'

import useStyles from './styles'

// The component receives an array of routes.
// If there is a url in the route, the InternalLink component is rendered, if not - plain text
const Breadcrumbs = ({ routes, onBackButtonClick, showBackBtn, className }) => {
  const classes = useStyles(showBackBtn)

  const { t } = useTranslation()

  return (
    <>
      {onBackButtonClick && (
        <button type="button" className={classes.backBtn} onClick={onBackButtonClick}>
          <IconBack /> {t('Back')}
        </button>
      )}
      <div className={classnames(classes.breadcrumbsRow, className)}>
        {routes.map((route, index) => {
          const isLastRoute = index === routes.length - 1

          return (
            <span className={classes.breadcrumbsItem} key={index}>
              {route.url ? (
                <InternalLink title={route.title} to={route.url} className={classes.breadcrumbsLink}>
                  {t(route.title)}
                </InternalLink>
              ) : (
                <span className={classes.text}>{t(route.title)}</span>
              )}
              {!isLastRoute && <ArrowIcon className={classes.arrowIcon} />}
            </span>
          )
        })}
      </div>
    </>
  )
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  routes: PropTypes.array,
  breadcrumbsBackBtn: PropTypes.node
}

export default Breadcrumbs
